"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfiniteScroll = void 0;
var listener_1 = require("../../utils/event-listener/listener");
var get_element_offset_1 = require("../../utils/get-element-offset");
var extend_1 = require("../../utils/extend");
var element_from_string_1 = require("../../utils/element-from-string");
var InfiniteScroll = function (target) {
    return /** @class */ (function (_super) {
        __extends(InfiniteScroll, _super);
        function InfiniteScroll() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            _this.lastParams = {};
            _this.loadingMore = _this.createLoadingMore();
            _this.loading = false;
            return _this;
        }
        InfiniteScroll.prototype.append = function (data) {
            this.loadingMore.remove();
            this.loading = false;
            _super.prototype.append.call(this, data);
            if (this.showLoadingMore(data)) {
                this.results.append(this.loadingMore);
                this.loadMoreIfNeeded();
            }
        };
        InfiniteScroll.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            select.on('query', function (params) {
                _this.lastParams = params;
                _this.loading = true;
            });
            select.on('query:append', function (params) {
                _this.lastParams = params;
                _this.loading = true;
            });
            listener_1.createListener({
                elements: this.results,
                events: 'scroll',
                listeners: this.core.listeners,
                callback: function () {
                    _this.loadMoreIfNeeded();
                }
            });
        };
        InfiniteScroll.prototype.loadMoreIfNeeded = function () {
            var isLoadMoreVisible = document.documentElement.contains(this.loadingMore);
            if (this.loading || !isLoadMoreVisible) {
                return;
            }
            var currentOffset = get_element_offset_1.getElementOffset(this.results).top + this.results.offsetHeight;
            var loadingMoreOffset = get_element_offset_1.getElementOffset(this.loadingMore).top + this.loadingMore.offsetHeight;
            if (currentOffset + 50 >= loadingMoreOffset) {
                this.loadMore();
            }
        };
        InfiniteScroll.prototype.loadMore = function () {
            this.loading = true;
            var params = extend_1.extend({}, { page: 1 }, this.lastParams);
            params.page++;
            this.trigger('query:append', params);
        };
        InfiniteScroll.prototype.showLoadingMore = function (data) {
            return data.pagination && data.pagination.more;
        };
        InfiniteScroll.prototype.createLoadingMore = function () {
            var option = element_from_string_1.elementFromString('<li ' +
                'class="select2-results__option select2-results__option--load-more"' +
                'role="option" aria-disabled="true"></li>');
            var message = this.options.get('translations').get('loadingMore');
            option.innerHTML = message(this.lastParams);
            return option;
        };
        return InfiniteScroll;
    }(target));
};
exports.InfiniteScroll = InfiniteScroll;
//# sourceMappingURL=infinite-scroll.js.map